import gql from 'graphql-tag'

export const queryApkVersions = gql`
query LIST_CLIENT_APP_VERSION ($params: ListQueryArgs, $app: appType!, $includeBeta: Boolean){
  listAppVersions(app: $app, params: $params, includeBeta: $includeBeta) {
    items {
      version
      timestamp
      description
    }
    cursors {
      after
      hasNext
    }
  }
}
`
export const updateAppVersionInstall = gql`
mutation updateAppVersionInstall($version: String!, $hardwareIds: [ID!]!, $app: appType!) {
	updateAppVersion(hardwareIds: $hardwareIds, app: $app, version: $version) {
  	version
  }
}
`
